import React, { useState, useEffect, useCallback, useRef } from 'react';
import Loading from './Loading';
import { useTemplateConfig } from '../context/TemplateConfigContext';
import UserInfoActions from '../actions/UserInfoActions';
import store from '../stores/redux';
import typeOf from '../helpers/typeOf';

const Locale = () => {
    const { assets } = useTemplateConfig();
    const locales = assets?.locales || [];

    const [state, setState] = useState({
        loading: false,
        loadingKey: '',
        locale: store.getState().user.locale
    });

    const getCurrentLocale = useCallback(() => {
        return locales.find((item) => item.key === state.locale);
    }, [state.locale, locales]);

    const getDataLocale = useCallback(() => {
        const data = getCurrentLocale();

        if (!data) return null;

        return (
            <span>
                <span className="locale__name">
                    <i className="flag-icon"><img src={data.image} alt={data.name}/></i>
                    {data.name}
                </span>
            </span>
        );
    }, [getCurrentLocale]);

    const onUpdate = useCallback((key) => {
        setState(prevState => ({
            ...prevState,
            loading: true,
            loadingKey: key
        }));

        UserInfoActions.edit({
            locale: key
        }).then(response);
    }, []);

    const response = useCallback((data) => {
        if (typeOf.isNumeric(data) && data === 1) {
            window.location.reload();
        } else {
            setState(prevState => ({
                ...prevState,
                loading: false
            }));
        }
    }, []);

    useEffect(() => {
        const data = getCurrentLocale();
        if (!data) {
            setState(prevState => ({
                ...prevState,
                locale: 'en'
            }));
            UserInfoActions.edit({
                locale: 'en'
            }).then(response);
        }
    }, [getCurrentLocale, response]);

    const data = getCurrentLocale();

    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const toggleDropdown = useCallback((event) => {
        event.preventDefault();
        setIsOpen(prev => !prev);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    if (!data) {
        return null;
    }

    return (
        <div className="locale" ref={dropdownRef}>
            <div className={`dropdown ${isOpen ? 'open' : ''}`}>
                <button
                    className="dropdown-toggle menu btn-empty bold"
                    onClick={toggleDropdown}
                >
                    {getDataLocale()}
                </button>
                <ul className="dropdown-menu">
                    {(locales || []).map((item) => (
                        <li key={item.key}>
                            <button
                                className={`${data && data.key === item.key ? 'active ' : ''}btn-empty${item.key.toUpperCase() === state.locale ? " disabled" : ""}`}
                                onClick={item.key !== state.locale ? () => {onUpdate(item.key)} : null}
                            >
                                <i className="flag-icon">
                                    <img src={item.image} alt="" />
                                </i>{item.name}
                            </button>
                            {state.loading && state.loadingKey === item.key
                                ? <div className="locale__loading"><Loading inherit={true} /></div>
                                : null
                            }
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default Locale;
